import { ref } from 'vue'

// Global "a route navigation is in flight" flag. Some routes resolve several API calls in their
// `beforeEnter` guard (e.g. the client detail page) before Vue Router actually switches the view,
// so without this the app just sits on the previous screen with no feedback while it loads.
const isNavigating = ref<boolean>(false)

export function useNavigationLoading() {
  function startLoading(): void {
    isNavigating.value = true
  }

  function stopLoading(): void {
    isNavigating.value = false
  }

  return {
    isNavigating,
    startLoading,
    stopLoading,
  }
}
